"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicOwnerDetailsForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactHookForm = require("react-hook-form");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _brandContext = require("../../../contextProviders/brandContext");
var _staffInstruction = require("../../StaffMode/staffInstruction");
var _PreloadWrapper = require("../../PreloadWrapper/PreloadWrapper");
var _form = require("../../../helpers/form");
var _selectors = require("../../../store/quote/selectors");
var _PromotionCode = require("./PromotionCode/PromotionCode");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable react/prop-types,react/forbid-prop-types,camelcase */
var BasicOwnerDetailsForm = exports.BasicOwnerDetailsForm = function BasicOwnerDetailsForm(_ref) {
  var _staffModeContext$pre;
  var isQuotePending = _ref.isQuotePending;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.savedQuoteSelector),
    savedQuote = _useSelector.quote;
  var dateOfBirthInput = (0, _react.useRef)(null);
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    staffMode = _useContext.staffMode,
    _useContext$activeBra = _useContext.activeBrandContext,
    _useContext$activeBra2 = _useContext$activeBra.brand,
    marketingPartner = _useContext$activeBra2.marketingPartner,
    glm = _useContext$activeBra2.glm,
    _useContext$activeBra3 = _useContext$activeBra.steps.basicOwnerDetails,
    heading = _useContext$activeBra3.heading,
    accordionBehaviour = _useContext$activeBra3.accordionBehaviour,
    showMembershipField = _useContext$activeBra3.showMembershipField,
    showPromoCodeField = _useContext$activeBra3.showPromoCodeField,
    showName = _useContext$activeBra3.showName,
    showBirthdate = _useContext$activeBra3.showBirthdate,
    showPostCode = _useContext$activeBra3.showPostCode,
    showMemberNumber = _useContext$activeBra3.showMemberNumber,
    showCustomerSource = _useContext$activeBra3.showCustomerSource,
    emailDisclaimerText = _useContext$activeBra3.emailDisclaimerText,
    ownerBirthdateInput = _useContext$activeBra3.ownerBirthdateInput,
    ownerEmailInput = _useContext$activeBra3.ownerEmailInput,
    ownerNameInput = _useContext$activeBra3.ownerNameInput,
    ownerPostCodeInput = _useContext$activeBra3.ownerPostCodeInput,
    ownerMembershipRadios = _useContext$activeBra3.ownerMembershipRadios,
    ownerMemberNumberInput = _useContext$activeBra3.ownerMemberNumberInput,
    basicOwnerFormOrder = _useContext$activeBra3.basicOwnerFormOrder,
    ownerMobileInput = _useContext$activeBra3.ownerMobileInput,
    mobileDisclaimerText = _useContext$activeBra3.mobileDisclaimerText,
    emailDomainPromos = _useContext$activeBra.promos.emailDomainPromos,
    staffModeContext = _useContext$activeBra.staffModeContext;
  var formContext = (0, _reactHookForm.useFormContext)();
  var owner = savedQuote.owner;
  var hasMemberNumber = (0, _reactHookForm.useWatch)({
    control: formContext.control,
    name: 'hasMemberNumber'
  });
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    emailValue = _useState2[0],
    setEmailValue = _useState2[1];
  var handleEmailChange = function handleEmailChange(event) {
    var newEmail = event.target.value;
    var emailDomain = newEmail.split(/[@]/)[1];
    if (emailDomainPromos && Array.isArray(emailDomainPromos.emailDomains) && emailDomainPromos.emailDomains.includes(emailDomain)) {
      setEmailValue(newEmail);
      formContext.setValue('promotionCode', emailDomainPromos.promoCode);
    }
  };
  var handleNameChange = function handleNameChange(event) {
    event.target.value = event.target.value.split(' ').map(function (namePiece) {
      return (0, _helpers.Capitalize)(namePiece);
    }).join(' ');
  };
  var handleMemberNumberChange = function handleMemberNumberChange(event) {
    var memberNumber = event.target.value;
    formContext.setValue('memberNumber', memberNumber);
  };
  var isUsingGlm3 = (glm === null || glm === void 0 ? void 0 : glm.version) === 3;
  var renderBasicOwnerFormComponent = function renderBasicOwnerFormComponent(item) {
    switch (item) {
      case 'ownerBirthdateInput':
        return /*#__PURE__*/_react["default"].createElement("fieldset", {
          ref: dateOfBirthInput
        }, showBirthdate && !isUsingGlm3 && /*#__PURE__*/_react["default"].createElement(_components.OwnerBirthdate, _extends({
          showSpinner: isQuotePending,
          fieldFormContext: formContext,
          autoComplete: "bday",
          name: "owner.dateofBirth",
          defaultValue: (0, _helpers.IsValidDate)(owner.dateofBirth) ? (0, _helpers.DateToShortIsoString)(owner.dateofBirth) : ''
        }, ownerBirthdateInput)));
      case 'ownerPostCodeInput':
        return /*#__PURE__*/_react["default"].createElement("fieldset", null, showPostCode && /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
          showSpinner: isQuotePending,
          fieldFormContext: formContext,
          name: "owner.postcode",
          autoComplete: "postal-code",
          defaultValue: owner.postcode
        }, ownerPostCodeInput)));
      case 'ownerEmailInput':
        return /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
          showSpinner: isQuotePending,
          fieldFormContext: formContext,
          name: "owner.email",
          autoComplete: "email",
          inputType: "email",
          defaultValue: owner.email,
          customChangeHandler: handleEmailChange
        }, ownerEmailInput, {
          customPostInputContent: emailDisclaimerText(marketingPartner)
        })));
      case 'ownerMobileInput':
        return /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
          showSpinner: isQuotePending,
          fieldFormContext: formContext,
          name: "owner.telephoneMobile",
          autoComplete: "tel",
          inputType: "tel",
          defaultValue: owner.telephoneMobile,
          maxLength: 10
        }, ownerMobileInput, {
          customPostInputContent: mobileDisclaimerText(marketingPartner)
        })));
      default:
        return null;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_components.SectionWrapper, {
    isFixed: accordionBehaviour,
    customCssClass: "ownerDetailsForm",
    heading: heading
  }, staffMode && (staffModeContext === null || staffModeContext === void 0 || (_staffModeContext$pre = staffModeContext.preScripts) === null || _staffModeContext$pre === void 0 || (_staffModeContext$pre = _staffModeContext$pre.aboutOwnerPreStart) === null || _staffModeContext$pre === void 0 ? void 0 : _staffModeContext$pre.map(function (aboutOwnerPreStartInstruction, index) {
    return /*#__PURE__*/_react["default"].createElement(_staffInstruction.StaffInstruction
    // eslint-disable-next-line react/no-array-index-key
    , _extends({
      key: "aboutOwnerPreStartInstruction".concat(index),
      instructionKey: "aboutOwnerPreStartInstruction"
    }, aboutOwnerPreStartInstruction));
  })), basicOwnerFormOrder === null || basicOwnerFormOrder === void 0 ? void 0 : basicOwnerFormOrder.map(function (item) {
    return renderBasicOwnerFormComponent(item);
  }), /*#__PURE__*/_react["default"].createElement("fieldset", null, showName && /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    showSpinner: isQuotePending,
    fieldFormContext: formContext,
    name: "owner.name",
    autoComplete: "name",
    defaultValue: (0, _helpers.FormatOwnerName)(owner),
    customChangeHandler: handleNameChange
  }, ownerNameInput))), showMembershipField && /*#__PURE__*/_react["default"].createElement(_PreloadWrapper.PreloadWrapper, {
    isLoading: isQuotePending
  }, /*#__PURE__*/_react["default"].createElement(_components.StyledRadios, _extends({
    fieldFormContext: formContext,
    groupName: "hasMemberNumber",
    name: "hasMemberNumber",
    required: true,
    value: _form.formHelpers.mapBooleanToRadioValue(hasMemberNumber !== null && hasMemberNumber !== void 0 ? hasMemberNumber : ownerMembershipRadios === null || ownerMembershipRadios === void 0 ? void 0 : ownerMembershipRadios.defaultRadioValue)
  }, ownerMembershipRadios))), showMembershipField && showMemberNumber && _form.formHelpers.mapRadioValueToBoolean(hasMemberNumber) && /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement(_components.InputText, _extends({
    showSpinner: isQuotePending,
    fieldFormContext: formContext,
    name: "memberNumber",
    autoComplete: "off",
    defaultValue: formContext.getValues('memberNumber'),
    customChangeHandler: handleMemberNumberChange
  }, ownerMemberNumberInput))), showPromoCodeField && /*#__PURE__*/_react["default"].createElement(_PromotionCode.PromotionCode, {
    emailValue: emailValue
  }));
};